module.exports = __webpack_public_path__ + "img/logo.91a7ff18.png";